import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
    AuthConfigService,
    BaseSiteService,
    GlobalMessageService,
    I18nModule,
    UrlModule,
    WindowRef
} from '@spartacus/core';
import {
    FormErrorsModule,
    OutletPosition,
    provideOutlet,
} from '@spartacus/storefront';
import { LoginFormComponentService, LoginFormModule } from '@spartacus/user/account/components';
import {
    VscaLoginFormComponent,
    VscaLoginFormComponentService,
} from '../../spartacus/features/user/account/components/login-form';

import { HttpClient } from '@angular/common/http';
import { VscaAuthService } from '../../../core/auth/user-auth/facade/vsca-auth.service';
import { LocationStripComponent } from '../../shared/modules/location-strip/location-strip.component';
import { LocationStripModule } from '../../shared/modules/location-strip/location-strip.module';
import { HomeScreenComponent } from './home-screen.component';
import { LoginComponent } from './login/login.component';

@NgModule({
  declarations: [HomeScreenComponent, LoginComponent],
  imports: [
    CommonModule,
    LoginFormModule,
    FormsModule,
    ReactiveFormsModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    LocationStripModule,
    RouterModule,
  ],

  providers: [
    provideOutlet({
      id: 'Section2B',
      position: OutletPosition.AFTER,
      component: VscaLoginFormComponent,
    }),
       {
      provide: VscaLoginFormComponentService,
      useClass: VscaLoginFormComponentService,
      deps: [ VscaAuthService, GlobalMessageService, WindowRef, HttpClient, AuthConfigService, BaseSiteService],
    },
    {
      provide: LoginFormComponentService,
      useExisting: VscaLoginFormComponentService,
    },
    provideOutlet({
      id: 'BottomHeaderSlot',
      position: OutletPosition.AFTER,
      component: LocationStripComponent,
    }),
  ],
})
export class HomeScreenModule {}
